import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Flex } from 'rebass';

import IconButton from '@/components/Button/IconButton';

import CheckTask from '../Icon/CheckTask';
import CloseTask from '../Icon/CloseTask';
import Text from '../Text';

export default function DefaultInput({ hideAction, initalValue, handleChangeInput, placeholder, ...props }) {
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState(initalValue);

  const handleFocus = () => {
    setFocused(true);
    hideAction?.(true);
  };

  const handleReset = () => {
    setValue(initalValue);
    setFocused(false);
    hideAction?.(false);
  };

  const handleSave = () => {
    if (value === '') {
      handleReset();
    } else {
      handleChangeInput(value);
      setFocused(false);
      hideAction?.(false);
      document.activeElement?.blur();
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    setValue(initalValue);
  }, [initalValue]);

  useEffect(() => {
    if (!focused && value === initalValue) {
      document.activeElement?.blur();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Flex flexDirection="column" width={['100%']}>
      <Flex>
        <Text
          {...props}
          as="input"
          onChange={handleChange}
          onBlur={handleSave}
          onFocus={handleFocus}
          placeholder={placeholder}
          sx={{
            '::placeholder': {
              color: '#a09e9e',
              fontWeight: 600,
            },
            borderColor: 'transparent',
            ':hover': { outline: 'none', borderColor: '#ebebeb' },
            ':focus': { outline: 'none' },
            ':active': { outline: 'none' },
            ':visited': { outline: 'none' },
            ':focus-visible': { outline: 'none', borderColor: '#333333' },
          }}
          width="100%"
          value={value}
        />
      </Flex>
      <Flex
        mt={['0.313rem']}
        textAlign="right"
        style={{
          display: focused ? 'block' : 'none',
        }}
      >
        <IconButton mr={['0.313rem']} onMouseDown={handleReset}>
          <CloseTask />
        </IconButton>
        <IconButton onMouseDown={handleSave}>
          <CheckTask />
        </IconButton>
      </Flex>
    </Flex>
  );
}

DefaultInput.propTypes = {
  handleChangeInput: PropTypes.func.isRequired,
  initalValue: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  hideAction: PropTypes.bool.isRequired,
};
